import React, { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../../constants/Theme';

interface DialogBodyProps {
  children: ReactNode;
}

const DialogBody = ({ children }: DialogBodyProps) => {
  const classes = useStyles();

  return <div className={classes.body}>{children}</div>;
};

const useStyles = createUseStyles({
  body: {
    marginTop: 32,
    marginBottom: 32,
    overflowY: 'auto',
    maxHeight: 400,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 1,
    '&::-webkit-scrollbar': {
      width: 5,
      height: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.colors.grey50,
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.colors.grey300,
      borderRadius: '4px',
      '&:hover': {
        background: theme.colors.greyMain,
      },
    },
  },
});

export default DialogBody;
